<template>
  <Breadcrumbs primary="Личный кабинет" secondary="Сервисные шаблоны"/>

  <el-tabs v-model="visiblePanel" class="primary-heading-tabs">
    <el-tab-pane label="Для СМС" name="sms">
      <client-service-templates-view
      />
    </el-tab-pane>
    <el-tab-pane label="Для Вконтакте / Одноклассники" name="vk">
      <vk-templates-table />
    </el-tab-pane>
  </el-tabs>
</template>

<script>

import VkTemplatesTable from "../../components/lk/vk-templates-table.component.vue";
import ClientServiceTemplatesView from "../../components/lk/service-templates-table.component.vue";

export default {
  name: "ServiceTemplates",
  title: "Шаблоны сервисных сообщений",
  components: {ClientServiceTemplatesView, VkTemplatesTable},
  data() {
    return {
      visiblePanel: "sms",
    }
  }
}

</script>